/*
 * The Steward's version, one number for the server, web and phone app. 4.x is the rebuilt Steward (the old WordPress
 * Steward ended at 3.170.1); 5.0.0 is when the phone app goes live in the stores. Change it with `npm run bump`.
 */
export const STEWARD_VERSION = "4.66.0";
